import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box } from '@components/common';
import { Calendar, CalendarViewFullItem } from '@components/Calendar';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import useDetectSize from '@hooks/useDetectSize';

function ServiceDateCalendarBoard(props) {
  const {
    selectedItems,
    month,
    year,
    weekRange,
    startDate,
    setStartDate,
    setMonth,
    setYear,
    disabled: calendarDisabled
  } = props;
  if (!selectedItems) {
    return null;
  }
  const isMobile = useDetectSize();

  let specialItems = {};

  if (startDate) {
    specialItems = selectedItems.reduce((acc, item) => {
      const { serviceType, addons, serviceDate } = item;
      if (!serviceDate) {
        return acc;
      }
      const { momentDate } = serviceDate;

      const serviceMonth = momentDate.month() + 1;
      const date = momentDate.date();

      if (!acc[serviceMonth]) {
        acc[serviceMonth] = {};
      }
      acc[serviceMonth][date] = {
        date,
        month: serviceMonth,
        serviceType,
        addons
      };
      return acc;
    }, {});
  }

  const renderItem = (specialItem, disabled) => {
    const { serviceType: serviceTypeIcon, addons } = specialItem;
    const iconFill = disabled ? 'darkGray' : undefined;

    const extraItems = addons
      ? addons.map(addon => ({
          icon: addon,
          name: addon,
          title: addon
        }))
      : undefined;

    const iconProps = isMobile
      ? { width: 24, height: 24 }
      : { width: 16, height: 16 };

    return (
      <CalendarViewFullItem
        iconFill={iconFill}
        serviceTypeIcon={serviceTypeIcon}
        extraItems={isMobile ? undefined : extraItems}
        iconProps={iconProps}
        disabled={disabled}
      />
    );
  };

  return (
    <Box display="flex" flexDirection="row">
      <Calendar
        specialItems={specialItems}
        renderSpecialItem={renderItem}
        highlightedRange={weekRange}
        month={month}
        year={year}
        onSelect={selectedDate => {
          if (!calendarDisabled) {
            setStartDate(selectedDate);
          }
        }}
        onPrev={() => {
          if (calendarDisabled) {
            return;
          }
          if (month === 1) {
            setMonth(12);
            setYear(year - 1);
            return;
          }
          setMonth(month - 1);
        }}
        onNext={() => {
          if (calendarDisabled) {
            return;
          }
          if (month === 12) {
            setMonth(1);
            setYear(year + 1);
            return;
          }
          setMonth(month + 1);
        }}
      />
    </Box>
  );
}

ServiceDateCalendarBoard.propTypes = {
  selectedItems: PropTypes.array,
  month: PropTypes.number,
  year: PropTypes.number,
  numOfRows: PropTypes.number,
  weekRange: PropTypes.object,
  startDate: PropTypes.object,
  setStartDate: PropTypes.func,
  setMonth: PropTypes.func,
  setYear: PropTypes.func,
  disabled: PropTypes.bool
};

const mapStatesToProps = state => ({
  selectedItems: ScheduleSelectors.selectScheduledItems(state),
  numOfRows: ScheduleSelectors.selectNumOfRows(state),
  month: ScheduleSelectors.selectCurrentMonth(state),
  year: ScheduleSelectors.selectCurrentYear(state),
  weekRange: ScheduleSelectors.selectWeekRange(state),
  startDate: ScheduleSelectors.selectStartDate(state)
});

const mapDispatchToProps = dispatch => ({
  setStartDate: startDate =>
    dispatch(ScheduleActions.setRecurringStartDate(startDate)),
  setMonth: month => dispatch(ScheduleActions.setRecurringCalendarMonth(month)),
  setYear: month => dispatch(ScheduleActions.setRecurringCalendarYear(month))
});
export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ServiceDateCalendarBoard);
